<template>
  <el-dialog
    :visible="detailsDialog"
    :before-close="closePackage"
    top="120px"
    width="1378px">
    <div class="left" v-if="state == 'video'">
      <div class="left_video" v-loading="Loading">
        <video :src="list.videoUrl" controls></video>
      </div>
      <div class="left_body">
        <div class="left_body_content"><span style="color: #3399CC;" v-if="list.postTopic">#{{list.postTopic.title}}#</span>{{list.content}}</div>
        <div class="left_body_time">{{getTime(list.createdDate)}}</div>
        <div class="left_body_right">
          <div class="item">
            <div class="itme_top"><img src="@/assets/imgs/article_look_left.png"></div>
            <div class="itme_foot">{{list.readNum}}</div>
          </div>
          <div class="item">
            <div class="itme_top" @click="likePostFun()">
              <img src="@/assets/imgs/article_like_left_click.png" v-if="list.like">
              <img src="@/assets/imgs/article_like_left.png" v-else>
            </div>
            <div class="itme_foot">{{list.likeNum}}</div>
          </div>
          <div class="item">
            <div class="itme_top" @click="collectFun()">
              <img src="@/assets/imgs/article_collect_left_click.png" v-if="list.favorite">
              <img src="@/assets/imgs/article_collect_left.png" v-else>
            </div>
          </div>
          <div class="item">
            <div class="itme_top"><img src="@/assets/imgs/article_left_left.png"></div>
            <div class="itme_foot">共有</div>
          </div>
        </div>
      </div>
    </div>
    <div class="left" v-if="state == 'post'">
      <div class="left_body" v-loading="Loading">
        <div class="left_body_post_time">{{getTime(list.createdDate)}}</div>
        <div class="left_body_post_content"><span style="color: #3399CC;" v-if="list.postTopic">#{{list.postTopic.title}}#</span>{{list.content}}</div>
        <div class="left_body_img">
          <img :src="item" v-for="(item,index) in list.images">
        </div>
        <div class="left_body_post_right">
          <div class="item">
            <div class="itme_top"><img src="@/assets/imgs/article_left_left.png"></div>
            <div class="itme_foot">共有</div>
          </div>
          <div class="item">
            <div class="itme_top" @click="collectFun()">
              <img src="@/assets/imgs/article_collect_left_click.png" v-if="list.favorite">
              <img src="@/assets/imgs/article_collect_left.png" v-else>
            </div>
          </div>
          <div class="item">
            <div class="itme_top" @click="likePostFun()">
              <img src="@/assets/imgs/article_like_left_click.png" v-if="list.like">
              <img src="@/assets/imgs/article_like_left.png" v-else>
            </div>
            <div class="itme_foot">{{list.likeNum}}</div>
          </div>
          <div class="item">
            <div class="itme_top"><img src="@/assets/imgs/article_look_left.png"></div>
            <div class="itme_foot">{{list.readNum}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="right_s">
      <div class="right_top">
        <div class="right_top_user">
          <div class="right_top_user_img"><img :src="list.creator.avatar" /></div>
          <div class="right_top_user_name">{{list.creator.nickname}}</div>
          <div class="right_top_user_follow" v-if="!list.creator.follow" @click="followFun()">フォローする</div>
          <div class="right_top_user_follow" v-else @click="followFun()">取消关注</div>
          <div class="right_top_commentNum">コメント {{list.commentNum}}</div>
          <div class="right_top_comment">
            <textarea v-model="comment"></textarea>
          </div>
          <div class="right_top_btn">
            <div @click="addComment()">送信</div>
          </div>
        </div>
      </div>
      <div class="right_comment" v-if="list">
        <comment :commentList="item" :post="list" v-for="(item, index) in comments" :key="index"></comment>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { getTime } from '@/assets/js/util'
  import * as json from '@/assets/js/json'
  import comment from '@/components/Dialog/comment'
  export default{
    props:{
      detailsDialog: {
        type: Boolean,
        default: false,
      },
      postList: {
        type: Object,
        default: function(){
          return {};
        },
      },
      videoList: {
        type: Object,
        default: function(){
          return {};
        },
      },
      state: {
        type: String,
        default: null,
      }
    },
    components: {
      comment
    },
    data() {
      return {
        list:{creator:{avatar:null}},
        Loading: false,
        comment: null,
        comments: [],
        commentsPage: 1,
      }
    },
    created () {
      this.getList()
      this.getCommentsList()
    },
    methods: {
      getList(){
        let options = {
          postId : null
        }
        this.Loading = true
        if(this.state == 'post'){
          options.postId = this.postList.id
        }else if(this.state == 'video'){
          options.postId = this.videoList.id
        }
        json.post('/api/member/post/watch',options).then(res => {
          this.list = res.data.data.post
          this.Loading = false
        })
      },
      getCommentsList(){
        let options = {
          postId : this.list.id,
          current : this.commentsPage
        }
        if(this.state == 'post'){
          options.postId = this.postList.id
        }else if(this.state == 'video'){
          options.postId = this.videoList.id
        }
        json.post('/api/member/post/comment/list',options).then((res) =>{
          let mergedArray= null
          if(this.commentsPage>1){
            mergedArray = this.comments.concat(res.data.data.page.records) 
          }else{
            mergedArray = res.data.data.page.records
          }
          this.comments = mergedArray
          this.comments.sort(function (a,b) {
            return b.createdDate - a.createdDate
          })
        })
      },
      addComment(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return false
        }
        if(!this.comment){
          this.$message.error('请输入评论内容')
          return false
        }
        const option = {
          postId : this.list.id,
          content : this.comment
        }
        json.post('/api/member/post/comment/add', option).then((res) =>{
          if(res.data.success){
            this.comment = null
            this.list.commentNum ++
            this.getCommentsList()
          }
        })
      },
      followFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        let option = {
          targetId: this.list.creator.id
        }
        if(!this.list.creator.follow){
          json.post('/api/member/follow/follow', option).then((res) =>{
            if(res.data.success){
              this.list.creator.follow = true
            }
          })
        }else{
          json.post('/api/member/follow/unfollow', option).then((res) =>{
            if(res.data.success){
              this.list.creator.follow = false
            }
          })
        }
      },
      collectFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        let options = {
          postId : this.list.id,
        }
        if(this.list.favorite){
          json.post('/api/member/post/favorite/delete', options).then((res) =>{
            this.getList()
          })
        }else{
          json.post('/api/member/post/favorite/add', options).then((res) =>{
            this.getList()
          })
        }
      },
      likePostFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        let options = {
          postId : this.list.id,
        }
        if(this.list.like){
          json.post('/api/member/post/unlike',options).then((res) =>{
            if(res.data.success){
              this.list.like = false
              this.list.likeNum --
            }
          })
        }else{
          json.post('/api/member/post/like',options).then((res) =>{
            if(res.data.success){
              this.list.like = true
              this.list.likeNum ++
            }
          })
        }
      },
      getTime(time){
        return getTime(time)
      },
      closePackage() {
        this.$emit("update:detailsDialog", false);
      },
    }
  }
</script>
<style>
  .el-dialog__title{
    color: #fff;
  }
  .el-dialog__header{
    background-color: #113651;
    padding-bottom: 20px
  }
  .el-dialog__headerbtn{
    top: 23px;
  }
  .el-dialog__body{
    /* padding: 0; */
    border-top: 20px solid #113651;
  }
  .add .el-dialog__body{
    /* padding: 0; */
    border-top: 0 solid #fff;
  }
  .left{
    width: 958px;
    height: 737px;
    background: #F6F6F6;
    display: inline-block;
    vertical-align: top;
  }
  .left_video{
    width: 958px;
    height: 560px;
    border-radius: 0px;
  }
  video{
    width: 100%;
    height: 100%;
  }
  .left_body{
    padding: 22px 28px;
    position: relative;
  }
  .left_body_post_time{
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
    margin-bottom: 12px;
  }
  .left_body_img{
    width: 500px;
    font-size: 16px;
    margin-top: 14px;
    margin-left: -7px;
  }
  .left_body_img img{
    width: 149px;
    height: 149px;
    border-radius: 6px;
    margin: 7px;
  }
  .left_body_content{
    width: 100%;
    height: 72px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
  .left_body_post_content{
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
  .left_body_time{
    position: absolute;
    top: 120px;
  }
  .left_body_right{
    position: absolute;
    top: 112px;
    right: 28px;
  }
  .left_body_right .item{
    display: inline-block;
    vertical-align: top;
    margin-left: 96px;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
    color: #666666;
  }
  .left_body_post_right{
    border-top: 1px solid #ccc;
    position: absolute;
    width: 904px;
    top: 635px;
    left: 33px;
  }
  .left_body_post_right .item{
    float: right;
    display: inline-block;
    vertical-align: top;
    margin-left: 96px;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
    color: #666666;
    padding-top: 22px;
  }
  .left_body_post_right .item:first-child{
    margin-right: 12px;
  }
  .itme_top{
    width: 23px;
    height: 22px;
  }
  .right_s{
    width: 376px;
    height: 737px;
    background: #FFFFFF;
    display: inline-block;
    vertical-align: top;
  }
  .right_top{
    margin: 22px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 0px;
  }
  .right_top_user_img{
    width: 50px;
    height: 50px;
    display: inline-block;
    vertical-align: top;
  }
  .right_top_user_img img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .right_top_user_name{
    height: 50px;
    display: inline-block;
    line-height: 50px;
    font-size: 16px;
    font-weight: 400;
    color: #010101;
    vertical-align: top;
    width: 170px;
    margin-left: 6px;
  }
  .right_top_user_follow{
    width: 97px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border: 1px solid #FF6633;
    display: inline-block;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
  }
  .right_top_commentNum{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    margin-top: 21px;
    margin-bottom: 10px;
    margin-left: 6px;
  }
  .right_top_comment textarea{
    width: 312px;
    height: 76px;
    resize:none;
    background: #EBEBEB;
    border-radius: 9px;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
    outline: none;
    padding: 5px 10px;
  }
  .right_top_btn{
    height: 23px;
    position: relative;
    margin-top: 10px;
    margin-bottom: 12px;
  }
  .right_top_btn div{
    width: 71px;
    height: 23px;
    border: 1px solid #E4E4E4;
    position: absolute;
    right: 0px;
    border-radius: 5px;
    text-align: center;
    line-height: 23px;
    cursor: pointer;
  }
  .right_comment{
    margin: 0px 22px;
    height: 420px;
    overflow-y: auto;
  }
  .right_comment::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .right_comment::-webkit-scrollbar-thumb {
    background-color: #FF6633;
    border-radius: 2.5px;
  }
  .right_comment::-webkit-scrollbar-track {
    background-color: #dbeffd;
    border-radius: 2.5px;
  }
</style>